<template>
  <b-modal id="modal-xl" hide-footer scrollable size="xl">
    <template #modal-title>
      <h3 class="text-success"><b>Terms Of Service</b></h3>
    </template>
    <h5 align="right">
      <b>Terms of Use</b><br /><br />
      Date of last update: July 1, 2020
    </h5>
    <br />
    <h5 style="text-indent: 2.5em">
      Welcome to
      <a href="https://www.sentenance.com/" target="_blank"> Sentenance</a>
      . The following terms and conditions (“Terms”) govern your use of and
      access to the websites, products, services and applications including but
      not limited to the Sentenance Platform (collectively, “Services”) of
      Sentenance. and its affiliates (“Sentenance,” “we”, and “us”) and your use
      of the Services constitutes agreement by you to the Terms. Please read
      these Terms carefully. The Terms constitute a legally binding agreement
      between you and us. If you do not agree to any of the Terms, you must not
      use the Services in any manner whatsoever. These Terms will remain in
      effect at all times while you use the Services or any data, designs,
      simulations, diagrams, renderings, calculations, cost estimates, models,
      images, reports or information obtained through use of or access to the
      Services (collectively, “Data”). These Terms govern your access to the
      Services and use of all Data on Sentenance’s websites, applications, and
      other properties and include the provisions in this document, as well as
      those in the Privacy Policy and the Cookies Policy.
    </h5>
    <br />
    <br />
    <h4><b>Changes</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      We may modify these Terms at any time. By logging in to the Sentenance
      Platform or using any other Services after these Terms have changed, you
      indicate your agreement to the revised Terms. If you do not agree to the
      changes, you should stop using the Services.
    </h5>
    <br /><br />
    <h4><b>Third Party Products and Services</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      The Services may contain links to third-party websites; we do not control
      or endorse those websites, nor endorse any goods or services sold on those
      websites except where expressly stated to the contrary on our website or
      in other Sentenance marketing materials. Similarly, the Services may
      contain ads for products or services of third parties. We do not control
      or endorse any such products or services being advertised except where
      expressly stated to the contrary on our website or in other Sentenance
      marketing materials.
    </h5>
    <br /><br />
    <h4><b>Access and Security</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      As part of using the Services, we may require you to sign up for an
      account and select a password and email or username (your “Sentenance
      User ID”). You promise to provide us with accurate, complete, and updated
      registration information about yourself. Your right to access the Services
      is personal to you and you may not transfer your account to anyone else
      without our prior written permission. You will not share your account or
      password with anyone, and you must protect the security of your account
      and your password. You may not select as your Sentenance User ID a name
      that you don’t have the right to use, or another person’s or entity’s name
      with the intent to impersonate that person or entity. You are responsible
      for any activity associated with your account. You are responsible for
      maintaining the confidentiality of your account and your password. You
      represent and warrant that you are of legal age to form a legally binding
      contract. If you are agreeing to these Terms on behalf of an entity, you
      represent and warrant that you are authorized to agree to these Terms on
      that entity’s behalf and bind them to these Terms (in which case, the
      references to “you” and “your” in these Terms, except for in this
      sentence, refer to that entity). Our websites are controlled and operated
      by us from Thailand, and, except as expressly set forth herein, are not
      intended to subject us to the laws or jurisdiction of any state, country
      or territory other than that of Thailand.
    </h5>
    <h5 class="mt-1" style="text-indent: 2.5em">
      In choosing to access the Services, you do so on your own initiative and
      at your own risk, and are responsible for complying with all local laws,
      rules and regulations. Sentenance may limit the Services’ availability, in
      whole or in part, to any person, geographic area or jurisdiction
      Sentenance chooses, at any time and in our sole discretion.
    </h5>

    <br /><br />
    <h4><b>Covenants</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      You agree that you will not provide any User Provided Information (as
      defined in these Terms) or other materials or otherwise use the Services
      or interact with the Services in any manner that:
    </h5>
    <h5 class="mt-3">
      <ul class="ml-5">
        <li class="mt-1">
          Infringes upon, misappropriates or violates the intellectual property
          rights or any other rights of Sentenance or any third party
        </li>
        <li class="mt-1">
          Violates any applicable laws, rules or regulations, including any
          applicable export control laws, or would cause Sentenance to be in
          violation of any applicable laws, rules or regulations
        </li>
        <li class="mt-1">
          Violates any agreement to which you are subject (including but not
          limited to any confidentiality or employment agreement)
        </li>
        <li class="mt-1">
          Is threatening, harassing, degrading, hateful, defamatory, fraudulent,
          tortious, obscene, indecent or objectionable
        </li>
        <li class="mt-1">
          Jeopardizes or interferes with the security of the Services, your
          Sentenance account or anyone else’s account
        </li>
        <li class="mt-1">
          Attempts, in any manner, to obtain the password, account, or other
          security information from any other user
        </li>
        <li class="mt-1">
          Violates or interferes with the security of any computer network, or
          cracks any passwords or security encryption codes
        </li>
        <li class="mt-1">
          Transmits, distributes or enables any virus, worm, Trojan horse or
          other code or program that is harmful or invasive or that is intended
          to damage or hijack the operation of any hardware or software
        </li>
        <li class="mt-1">
          Attempts to disrupt, interfere with or slow down our delivery of
          Services, including but not limited to a denial of service attack
        </li>
        <li class="mt-1">
          “Crawls,” indexes, “scrapes,” or “spiders” any page, data, or portion
          of or relating to the Services or Data (through use of manual or
          automated means)
        </li>
        <li class="mt-1">
          Circumvents or attempts to circumvent any features, limitations, or
          restrictions of the Services (including, without limitation,
          attempting to access, download, export, or otherwise use or exploit
          any Data using any automated means or tools or to attempt to obtain
          paid services without making paymen
        </li>
        <li class="mt-1">
          Runs any form of auto-responder or “spam” on the Services, or any
          processes that run or are activated while you are not logged into the
          Services, or that otherwise interfere with the proper working of the
          Services (including by placing an unreasonable load on the Services’
          infrastructure)
        </li>
        <li class="mt-1">
          Copies or stores any significant portion of the Data in any manner not
          expressly permitted by the Terms (e.g. creating a database by
          systematically downloading or storing Data)
        </li>
        <li class="mt-1">
          Decompiles, reverse engineers, translates, creates derivative works
          from, obtains, or reproduces any code or underlying ideas, inventions,
          technology, algorithms or functionality of or relating to the Services
          or Data, or attempts to do so
        </li>
      </ul>
    </h5>
    <br /><br />
    <h4><b>User Provided Information</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      Sentenance Platform provides opportunities for you to provide data,
      content, photographs, layouts, diagrams, models, files or other
      information (collectively, “User Provided Information”) to us in
      connection with your use of the Services. You agree you will only provide
      User Provided Information to us if you own all the rights to that User
      Provided Information, or if another rights holder has given you
      permission. You do not transfer ownership of your User Provided
      Information simply by providing it to us.
    </h5>
    <h5 class="mt-1" style="text-indent: 2.5em">
      Your User Provided Information is owned by you or the respective licensors
      or property owners.
    </h5>
    <h5 class="mt-1" style="text-indent: 2.5em">
      By providing us with User Provided Information, you grant, on your own
      behalf and on the behalf of such licensors or property owners, to
      Sentenance and its affiliates the right to use User Provided Information
      (a) to provide Services to you(b) for the purpose of system maintenance,
      including but not limited to implementing and verifying Sentenance
      Platform security maintenance/upgrades, and for maintenance of the
      Services. t(c) on an aggregated basis (and not in a manner that identifies
      individual users/projects) for the purpose of improving the Sentenance
      Platform and Services and (d) on an aggregated basis (and not in a manner
      that identifies individual users/projects) for our research on Sentenance
      customer and project demographics, interests, and behavior and marketing
      and business development purposes.
    </h5>
    <h5 class="mt-1" style="text-indent: 2.5em">
      Your User Provided Information, including generated simulations and
      configurations provided to you through your use of our Services, will be
      treated by Sentenance as confidential and will not be disclosed by
      Sentenance or its affiliates to any party for any purpose not permitted by
      these Terms provided that we may disclose such information for the purpose
      of complying with the order or requirement of a court, administrative
      agency or other governmental body or other applicable legal requirement
      provided that we will use commercially reasonable efforts to notify you in
      advance of such disclosure.
    </h5>
    <h5 class="mt-1" style="text-indent: 2.5em">
      You agree that you will not knowingly, intentionally or recklessly provide
      any User Provided Information that is not accurate, true and complete and
      agree that you will make reasonable efforts to maintain and update such
      information as appropriate. You acknowledge that Sentenance is not
      responsible in any respect for the accuracy, truth, or completeness of any
      User Provided Information. You agree to indemnify, release, and hold us
      harmless from any all liability, claims, actions, loss, harm, damage,
      injury, cost or expense arising out of any User Provided Information you
      provide.
    </h5>
    <br /><br />
    <h4><b>Intellectual Property</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      The Services and the Data constitute the property of Sentenance and/or
      Sentenance’s suppliers and licensors, as applicable, and are protected by
      copyright, trademark, patent and/or other proprietary rights and laws.
      Sentenance and/or its suppliers and licensors retain all of their
      respective intellectual property rights in the Services and Data and no
      such rights are conveyed to you by these Terms or your use of the Services
      or Data other than the limited rights expressly granted to you in these
      Terms. Any reproduction, transmission, publication, transfer, resale,
      creation of derivative works from, redistribution or other use or
      exploitation of the Services or Data by you not expressly in accordance
      with these Terms, including without limitation any effort to resell or
      distribute all or any part of any Services or Data or any technology or
      functionality underlying the Services or Data, is expressly prohibited and
      may result in civil or criminal penalties.
    </h5>
    <h5 class="mt-1" style="text-indent: 2.5em">
      In addition, you promise to abide by all copyright notices, trademark
      rules, information, and restrictions contained in any Data you access
      through the Services in any way (including through the Sentenance website,
      API, mobile applications, downloads, etc.). You will not use, copy,
      reproduce, modify, translate, publish, broadcast, transmit, distribute,
      perform, upload, display, license, sell or otherwise exploit for any
      purpose any Data in a way that violates someone else’s (including
      Sentenance’s) rights. You may reference the Data with proper attribution
      to Sentenance or the applicable owner; however, any other uses of the Data
      require Sentenance’s prior written consent. You grant to Sentenance a
      worldwide, perpetual, irrevocable, royalty-free license to use and
      incorporate into the Services any suggestion, enhancement request,
      recommendation, correction or other feedback provided by you relating to
      the Services.
    </h5>
    <br /><br />
    <h4><b>Sentenance Platform</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      By accessing and using the Sentenance Platform, you agree additionally to
      the terms of this section “Sentenance Platform” (without limitation to the
      other provisions of the Terms). The Sentenance Platform is an IoT and
      facility management platform. It is intended to enable users to
      collaborate on various activities for smart facility management. You agree
      that any usage by you of the Sentenance Platform shall solely be for the
      purpose of facility management and for your personal or your
      organization’s purposes (including downloading, and making and
      distributing copies, of such generated simulations/configurations
      exclusively in furtherance of this authorized purpose) (the “Permitted
      Purpose”).
    </h5>
    <br /><br />
    <h4><b>Privacy Electronic Communications</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      Your use of the Services and provision of User Provided Information is
      governed by our Privacy Policy (www.Sentenance.com/privacy), which is
      incorporated by reference as if fully set forth herein. Your use of or
      access to the Services constitutes your agreement to our collection, use
      and disclosure of your User Provided Information in accordance with the
      Privacy Policy. Sentenance uses its best efforts to implement and maintain
      prudent, reasonable measures to maintain security and confidentiality of
      User Provided Information in accordance with these Terms.
    </h5>
    <h5 class="mt-1" style="text-indent: 2.5em">
      You consent to receive electronically any communications related to your
      use of the Services. We may communicate with you by email or by posting
      notices on our websites. You agree that all agreements, notices,
      disclosures and other communications that are provided to you
      electronically satisfy any legal requirement that such communications be
      in writing. All notices from us intended for receipt by you shall be
      deemed delivered and effective when sent to the email address you provide
      to us. Please note that by submitting User Provided Information, creating
      a user account or otherwise providing us with your email address, postal
      address or phone number, you are agreeing that we or our agents may
      contact you at that address and number in a manner consistent with our
      Privacy Policy.
    </h5>
    <br /><br />
    <h4><b>Fees</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      We reserve the right to charge for certain or all Services. Visit our
      products page for current descriptions of these services and the
      applicable fees or contact your sales representatives. You agree to pay
      all fees which apply to your use of the Services. Sentenance reserves the
      right to change any fees and pricing applicable to the Services at any
      time upon notice to you (which may be sent by email or posted on
      Sentenance’s website). Your use of the Services following such
      notification constitutes your acceptance of any new or increased fees.
      Payment obligations are non-cancelable and fees paid are non-refundable.
      Quantities purchased cannot be decreased once purchased. If you provide
      credit card or bank account information to us for payment for Services,
      you authorize us to charge your credit card or bank account for such
      Services. You are responsible for providing accurate credit card or bank
      account information and notifying us of any changes to such information.
      Fees do not include any taxes, levies, duties or similar governmental
      assessments of any kind, including, without limitation, value-added,
      sales, use or withholding taxes (collectively, “Taxes”) and you are
      responsible for paying all Taxes associated with any purchases of any
      Services. We are responsible solely for taxes assessable against us based
      on our income, property and employees.
    </h5>
    <br /><br />
    <h4><b>Termination</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      Sentenance may, in its sole discretion, at any time for any reason or no
      reason, terminate your access to the Services and any account(s) you may
      have in connection with this Services, including if Sentenance believes
      that you have violated or acted inconsistently with the letter or spirit
      of these Terms or if it is required by applicable law, rule or regulation.
    </h5>
    <h5 class="mt-1" style="text-indent: 2.5em">
      Our termination of your access to the Services may be effected without
      notice and, on such termination, we may immediately deactivate or delete
      your account and/or bar any further access to such files, and your right
      to use the Services will immediately cease. Sentenance shall not be liable
      to you or any third party for any termination of your access to the
      Services or account hereunder.
    </h5>
    <br /><br />
    <h4><b>Modifications</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      The Services may change over time. We may suspend or discontinue all or
      any part of the Services, or we may introduce new features or impose
      limits on certain features or restrict access to parts or all of the
      Services. Similarly, we reserve the right to remove any User Provided
      Information from the Services at any time in the event that we determine
      in our discretion that you have breached the Terms.
    </h5>
    <br /><br />
    <h4><b>General</b></h4>
    <br />
    <h4><b>Disclaimer of Warranties</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      Your use of the Services is at your own risk. The Services and any
      content, information, products or services made available on or through
      the Services are provided on an “as is” and “as available” basis without
      warranty of any kind except to the extent expressly provided to the
      contrary by Sentenance to you in writing. Except to the extent of any
      express warranty made to you by Sentenance in writing, Sentenance and/or
      its suppliers and licensors hereby disclaim all warranties, express or
      implied, in relation to the Services or any content, information, products
      or services made available on or through the Services, including but not
      limited to any implied warranty of merchantability, fitness for a
      particular a purpose or noninfringement, to the maximum extent permissible
      under applicable law.
    </h5>
    <br /><br />
    <h4><b>Limitation of Liability</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      In no event shall Sentenance and/or its suppliers/licensors and its or
      their officers, directors, employees, or agents be liable for any special,
      incidental or consequential or punitive damages or losses arising out of
      or in connection with your use of the Services or the Terms, however
      arising, including by contract, equity, negligence or other tortious
      action, even if advised in advance of such damages or losses. The maximum
      liability of Sentenance and its officers, directors, employees and agents
      to you or any third party shall be the total amount, if any, actually paid
      by you to access and use the Services.
    </h5>
    <br /><br />
    <h4><b>Indemnity</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      To the fullest extent permitted by law, you shall indemnify, defend and
      hold harmless Sentenance, its licensors/suppliers and their respective
      officers, directors, employees and agents from any and all claims,
      demands, damages, costs and liabilities, including reasonable attorneys’
      fees, arising out of or in connection with: (1) any of your User Provided
      Information, including an assertion that the information, content, or
      other materials or services provided or made available by you or the use
      thereof, may infringe any copyright, trademark, or other intellectual
      property rights of any individual or entity, or misappropriate any
      individual or entity’s trade secret, or contain any libelous, defamatory,
      disparaging, pornographic, or obscene materials; (2) any breach by you of
      your obligations or covenants under these Terms; (3) your unlawful and/or
      unauthorized use of, or activities in connection with the Services
      including any Sentenance websites. The foregoing indemnities shall survive
      expiration or termination of these Terms.
    </h5>

    <br /><br />
    <h4><b>Assignment</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      You may not assign, delegate or transfer these Terms or your rights or
      obligations hereunder, or your Services account, in any way (by operation
      of law or otherwise) without Sentenance’s prior written consent. We may
      transfer, assign, or delegate these Terms and our rights and obligations
      without consent.
    </h5>
    <br /><br />
    <h4><b>Choice of Law</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      Terms are governed by and will be construed under Thailand law, without
      regard to the conflicts of laws provisions thereof. Any dispute arising
      from or relating to the subject matter of these Terms (whether brought
      against Sentenance or against any director, officer or employee of
      Sentenance in their personal capacity) shall be finally settled in
      Thailand, in Thai language.
    </h5>
    <br /><br />
    <h4><b>Miscellaneous</b></h4>
    <br />
    <h5 style="text-indent: 2.5em">
      The failure of either you or us to exercise, in any way, any right herein
      shall not be deemed a waiver of any further rights hereunder. If any
      provision of these Terms is found to be unenforceable or invalid, that
      provision will be limited or eliminated, to the minimum extent necessary,
      so that these Terms shall otherwise remain in full force and effect and
      enforceable. Except where expressly agreed in writing otherwise, and
      except for our Privacy Policy, you and Sentenance agree that these Terms
      are the complete and exclusive statement of the mutual understanding
      between you and Sentenance, and that it supersedes and cancels all
      previous written and oral agreements, communications and other
      understandings relating to the subject matter of these Terms. You hereby
      acknowledge and agree that you are not an employee, agent, partner, or
      joint venture of Sentenance, and you do not have any authority of any kind
      to bind Sentenance in any respect whatsoever. You and Sentenance agree
      there are no third party beneficiaries intended under these Terms.
    </h5>
    <h5 class="mt-1" style="text-indent: 2.5em">
      If you have any general question, comment or complaint regarding the
      Services, please send an e-mail to <a href> info@Sentenance.com.</a>
    </h5>
    <br />
  </b-modal>
</template>

<script>
export default {
};
</script>

<style>
</style>